import { useEffect, useRef } from "react";

export const PayLaterMessage = () => {
  const ref = useRef(null);

  useEffect(() => {
    try {
      if (window.PayPalSDK?.Messages && ref.current) {
        window.PayPalSDK.Messages().render(ref.current);
      }
    } catch (e) {
      // third-party SDK failure — message simply doesn't render
    }
  }, []);

  return (
    <div data-testid="paypal-paylater-message"
      className="bg-white border-l-4 border-brand border-y border-r border-zinc-200 rounded-sm px-5 py-4">
      <div
        ref={ref}
        data-pp-message
        data-pp-style-layout="text"
        data-pp-style-logo-type="inline"
        data-pp-style-text-color="black"
        data-pp-amount="10000"
        data-pp-language=""
      />
    </div>
  );
};
